import { AdProviderNames } from '@/types'

export const AD_STORE_DEFAULT_PROVIDERS_FOR_GAME_PAGE_ON_PORTAL: AdProviderNames[] = [
    AdProviderNames.GOOGLE_INSTREAM,
    AdProviderNames.GOOGLE_AD,
    AdProviderNames.GOOGLE_AD_SENSE,
]

export const AD_STORE_DEFAULT_PROVIDERS_FOR_GAME_PAGE_OUT_OF_PORTAL: AdProviderNames[] = [
    AdProviderNames.GOOGLE_INSTREAM,
    AdProviderNames.GOOGLE_AD,
]
